import { createContext } from "react"
import { Lot, ResponseStatus } from "../../api/dtos";

export interface ILotContext {
    data?: Lot;
    code?: string;
    error?: ResponseStatus;
    loading: boolean;
    validating: boolean;
    refresh: () => Promise<Lot | undefined>
}

export const LotContext = createContext<ILotContext>({
    loading: false,
    validating: false,
    data: undefined,
    error: undefined,
    refresh: () => {
        return new Promise<Lot | undefined>(res => {
            res(undefined);
        });
    }
});

export default LotContext;